import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'BigData';
  stars: number[] = [1, 2, 3, 4, 5];
  selectedValue: number;

  ngOnInit() {
    console.log(environment.version);
  }


}
